var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_4134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 13.9944V12.6616C10.6621 11.9547 10.3812 11.2767 9.88136 10.7768C9.38148 10.2769 8.70349 9.99609 7.99656 9.99609H3.99828C3.29134 9.99609 2.61336 10.2769 2.11348 10.7768C1.61359 11.2767 1.33276 11.9547 1.33276 12.6616V13.9944",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99743 7.33103C7.46955 7.33103 8.66294 6.13764 8.66294 4.66552C8.66294 3.19339 7.46955 2 5.99743 2C4.5253 2 3.33191 3.19339 3.33191 4.66552C3.33191 6.13764 4.5253 7.33103 5.99743 7.33103Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6603 13.9937V12.6609C14.6599 12.0703 14.4633 11.4966 14.1015 11.0298C13.7396 10.5631 13.233 10.2297 12.6612 10.082",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 2.08594C11.2354 2.23274 11.7436 2.5662 12.1065 3.03374C12.4695 3.50127 12.6664 4.0763 12.6664 4.66816C12.6664 5.26001 12.4695 5.83504 12.1065 6.30258C11.7436 6.77012 11.2354 7.10357 10.6621 7.25038",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_4134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGray);
export default __webpack_public_path__ + "static/media/person_gray.a6090c89a83b67bb554ee6e402e5f3af.svg";
export { ForwardRef as ReactComponent };